import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { createPortal } from "react-dom";
import logo from "../img/black.png";

import { useAuth } from "../AuthContext";

import style from "../style/components/Header.module.css";
let count = 0;
const Header = () => {
    const { user } = useAuth();
    const [log, setLog] = useState<boolean>(false);

    const refresh = () => {
        count++;
        if (count > 5) {
            window.location.href = `${window.location.pathname}?t=${Date.now()}`;
        }
    };

    return (
        <div className={style["container"]}>
            <div onClick={refresh}>
                <img src={logo} style={{ display: "block", height: "72px", margin: "0px auto 0px -18px" }} />
            </div>
            {log && user?.displayName == "테스트" && <LogDisplay close={() => setLog(false)} />}
        </div>
    );
};

export const LogDisplay = ({ close, content }: { close: () => void; content?: string }) => {
    const [logOutput, setLogOutput] = useState<string>("");

    useEffect(() => {
        const originalConsoleLog = console.log;
        console.log = (...args: any[]) => {
            setLogOutput((prevLogOutput) => `${prevLogOutput}\n${args.join(" ")}`);
            originalConsoleLog(...args);
        };

        return () => {
            console.log = originalConsoleLog;
        };
    }, []);

    return createPortal(
        <div className={style["container--log"]}>
            <p>
                {logOutput}
                {content ? `content: ${content}` : ""}
            </p>
            <button
                onClick={() => {
                    window.location.href = `${window.location.pathname}?t=${Date.now()}`;
                }}
            >
                새로고침
            </button>
            <button onClick={() => setLogOutput("")}>로그 지우기</button>
            <button onClick={close}>로그창 종료</button>
        </div>,
        document.body
    );
};

export default Header;
